function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgSms = function SvgSms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.968 495.968",
    style: {
      enableBackground: "new 0 0 495.968 495.968"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#2196F3"
    },
    d: "M423.984,0h-352c-35.296,0-64,28.704-64,64v288c0,35.296,28.704,64,64,64v63.968 c0,6.208,3.584,11.84,9.216,14.496c2.144,0.992,4.48,1.504,6.784,1.504c3.68,0,7.328-1.248,10.24-3.712L189.776,416h234.208 c35.296,0,64-28.704,64-64V64C487.984,28.704,459.28,0,423.984,0z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M119.984,288h-32c-8.832,0-16-7.168-16-16s7.168-16,16-16h32c8.832,0,16-7.168,16-16 s-7.168-16-16-16c-26.464,0-48-21.536-48-48s21.536-48,48-48h32c8.832,0,16,7.168,16,16s-7.168,16-16,16h-32 c-8.832,0-16,7.168-16,16s7.168,16,16,16c26.464,0,48,21.536,48,48S146.448,288,119.984,288z"
  }), React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M375.984,288h-32c-8.832,0-16-7.168-16-16s7.168-16,16-16h32c8.8,0,16-7.168,16-16s-7.2-16-16-16 c-26.464,0-48-21.536-48-48s21.536-48,48-48h32c8.832,0,16,7.168,16,16s-7.168,16-16,16h-32c-8.8,0-16,7.168-16,16s7.2,16,16,16 c26.464,0,48,21.536,48,48S402.448,288,375.984,288z"
  }), React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M279.984,288c-8.832,0-16-7.168-16-16v-60.224l-1.696,3.392c-5.44,10.848-23.2,10.848-28.64,0 l-1.664-3.392V272c0,8.832-7.168,16-16,16s-16-7.168-16-16V144c0-7.424,5.12-13.888,12.32-15.584 c7.136-1.728,14.656,1.792,17.984,8.416l17.696,35.392l17.696-35.36c3.296-6.688,10.624-10.144,17.984-8.448 c7.232,1.696,12.32,8.16,12.32,15.584v128C295.984,280.832,288.816,288,279.984,288z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms.550a7b4b.svg";
export { ForwardRef as ReactComponent };